export function getVideoDuration(file) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith('video')) {
      reject(new Error('Not a video file'));
      return;
    }

    const video = document.createElement('video');
    video.preload = 'metadata';

    video.onloadedmetadata = () => {
      resolve(video.duration);
      URL.revokeObjectURL(video.src);
    };

    video.onerror = () => {
      reject(new Error('Unable to load video metadata'));
    };

    video.src = URL.createObjectURL(file);
  });
}
